import modernTemplates from './modern/index';
import sportsTemplates from './sports/index';
import eventsTemplates from './events/index';

export default {
  modern: {
    title: 'Modern',
    templates: modernTemplates,
  },

  sports: {
    title: 'Sports',
    templates: sportsTemplates,
  },

  events: {
    title: 'Events',
    templates: eventsTemplates,
  },
};
